import React from "react"
import styles from "./FormSection.module.scss"
import cn from "classnames"

export interface FormSectionProps {
    border?: boolean
    indent?: boolean
    withoutPadding?: boolean
}

const FormSection: React.FC<FormSectionProps> = ({ children, border, indent, withoutPadding }) => {
    return (
        <div
            className={cn(
                styles.formSection,
                border && styles.formSection_border,
                indent && styles.formSection_indent,
                withoutPadding && styles.formSection_withoutPadding
            )}
        >
            {children}
        </div>
    )
}

export default FormSection
